import {RouterProvider} from "react-router-dom";
import {router} from "./router/Router";
import {useHotjar} from "./hooks/useHotjarScript";
import {useClarity} from "./hooks/useClarityScript";
import ClarityConsentBanner from "./components/ClarityConsentBanner";

const App = () => {
    useHotjar();
    useClarity();

    return (
        <>
            <RouterProvider router={router} />
            <ClarityConsentBanner />
        </>
    );
};

export default App;
